import Layout from "../include/layout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {Button,  Container,  Form, Modal, Row, Table} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { myroutes } from "../../routes/webroute";
import { checkAuthenticate } from "../app/providers/authSlice";
import MatieresService from "../matieres/MatieresService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ClassesService from "../classe/ClassesService";
import ClassesoptionsService from "../classesoptions/ClassesoptionsService";
import makeAnimated from "react-select/animated";
import AdminService from "../auth/AdminService";
import Filarial from "../include/filarial";
import AnneesacademiquesService from "../anneesacademiques/AnneesacademiquesService";
import CoursService from "./CoursService";
import PersonnesService from "../personnes/PersonnesService";
import EnseignantsService from "../enseignants/EnseignantsService";

export default function CoursCreate() {
  const activeLink = "Cours";

  const [matiereId, setMatiereId] = useState("");
  const [matieres, setMatieres] = useState([]);
  const [classeId, setClasseId] = useState("");
  const [classes, setClasses] = useState([]);
  const [classeoptionId, setClasseoptionId] = useState("");
  const [classesoptions, setClassesoptions] = useState([]);
  const [enseignantId, setEnseignantId] = useState("");
  const [enseignants, setEnseignants] = useState([]);
  const [personnes, setPersonnes] = useState([]);
  const [dateCours, setDateCours] = useState("");
  const [heuredebutCours, setHeuredebutCours] = useState("");
  const [heurefinCours, setheurefinCours] = useState("");
  const [descriptionCours, setDescriptionCours] = useState("");
  const [anneeacademiqueId, setAnneeacademiqueId] = useState("");
  const [anneesacademiques, setAnneesacademiques] = useState([]);
  const [jourId, setJourId] = useState("");
  const [jours, setJours] = useState([]);
  const [selectedMatiereId, setSelectedMatiereId] = useState(null);
  const [selectedEnseignantId, setSelectedEnseignantId] = useState(null);
  const [selectedAnneeAcademique, setSelectedAnneeAcademique] = useState("");





  ///Variable pour enregistrer une matière
  const [libelleMatiere, setLibelleMatiere] = useState("");
  const [descriptionMatiere, setDescriptionMatiere] = useState("");
  const [coefficientMatiere, setCoefficientMatiere] = useState("");

  //ajout de ligne
  const [groupCount, setGroupCount] = useState(1);
 
  const [date, setDate] = useState(null);

  //Afficher le modal de détail user
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();
  const location = useLocation()


  const animatedComponents = makeAnimated();
  const [validationError, setValidationError] = useState({});

  const [rowData, setRowData] = useState([{
    matiereId: "",
    id: "",
    enseignantId: "",
    jourId: "",
    heuredebutCours: "",
    heurefinCours: "",
    enseignants: [],
  }]);


  //check if user is authenticated
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticate);

  ///Get liste des classes
  const fetchClasses = async () => {
    await ClassesService.index(token)
      .then((res) => {
        //console.log(res.data.data)
        setClasses(res.data.data.classes);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  ///Get liste des classes options
  const fetchClassesoptions = async () => {
    await ClassesoptionsService.index(token)
      .then((res) => {
        //console.log(res.data.data)
        setClassesoptions(res.data.data.classesoptions);
      })
      .catch((error) => {
        console.log(error);
      });
  };

    //get liste enseignants
    const fetchEnseignants = async () => {
      await EnseignantsService.index(token).then((res) => {
         // console.log(res.data.data.enseignants)
          setEnseignants(res.data.data.enseignants)
      }).catch(error => {
          console.log(error)
      })
  }

     //get liste annees academiques
     const fetchAnnesacademiques = async () => {
      await AnneesacademiquesService.index(token).then((res) => {
         // console.log(res.data.data.anneesacademiques)
          setAnneesacademiques(res.data.data.anneesacademiques)
      }).catch(error => {
          console.log(error)
      })
  }

     //get liste jours
     const fetchJours = async () => {
      await CoursService.index_jours(token).then((res) => {
          setJours(res.data.data.jours)
      }).catch(error => {
          console.log(error)
      })
  }



  //get liste matières
  const fetchMatieres = async () => {
    await MatieresService.index(token)
      .then((res) => {
      // console.log("ok",res.data.data.matieres)
        setMatieres(res.data.data.matieres);
      })
      .catch((error) => {
        console.log(error);
      });
  };

    //get liste personnes
    const fetchPersonnes = async () => {
      await PersonnesService.index(token)
        .then((res) => {
          //  console.log(res.data.data.personnes)
          setPersonnes(res.data.data.personnes);
        })
        .catch((error) => {
          console.log(error);
        });
    };
  
    
  
  const storeMatiere = async (event) => {
    event.preventDefault();

    let form = {
      libelleMatiere,
      descriptionMatiere,
      coefficientMatiere,
    };

    await MatieresService.store(form, token)
      .then((response) => {
        //console.log(response.data.data)
        if (response.data.status === 200) {
          Swal.fire({
            icon: "success",
            text: response.data.message,
            timer: 3000,
          });
          //Mettre à jour la liste des matières
          fetchMatieres();
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message,
            showConfirmButton: true,
            timer: 3000,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          text: error.message,
        });
        //affichage des erreurs sur le formulaire
        //setValidationError(error.message)
      });

    //Fermer le modal
    return setShow(false);
  };

  //get edit data
  const edit = async () => {
    await CoursService.show(location.state.id, token).then((response) => {
        const data = response.data.data
         // Récupérer l'ID de l'année académique
         setAnneeacademiqueId(data.anneesacademiques.id)
         setClasseoptionId(data.classesoptions.id)
         setDescriptionCours(data.descriptionCours)
         console.log(descriptionCours)
        const updatedRowData = [...rowData];
        updatedRowData[0].matiereId = data.matieres.id;
        updatedRowData[0].jourId = data.jours.id;

      //récupérer le nom et prénoms des enseignnats 
        updatedRowData[0].enseignants = [{
          id: data.enseignants.id,
          personnes: {
            nomPersonne: data.enseignants.personnes.nomPersonne,
            prenomsPersonne: data.enseignants.personnes.prenomsPersonne
          }
        }];

        updatedRowData[0].heuredebutCours = data.heuredebutCours;

        updatedRowData[0].heurefinCours = data.heurefinCours;

        
        
        setRowData(updatedRowData);
        
        

    }).catch(error => {
        Swal.fire({
            icon: "error",
            text: error.message
        })
    });
}

  const handleSubmitData = async (e) => {
    e.preventDefault();

    let id = location.state.id

    for (let i = 0; i < rowData.length; i++) {
      const row = rowData[i];

      const updatedMatiereId = row.matiereId;
        setMatiereId(updatedMatiereId);

        const updatedEnseignantId = row.enseignantId;
        setEnseignantId(updatedEnseignantId);


        const updatedHeuredebutCours = row.heuredebutCours;
        setHeuredebutCours(updatedHeuredebutCours);

        const updatedHeurefinCours = row.heurefinCours;
        setheurefinCours(updatedHeurefinCours);

        const updatedJourId = row.jourId;
        setJourId(updatedJourId);


      const formData = new FormData();
      formData.append("id", id);
      formData.append("matiereId", updatedMatiereId);
      formData.append("classeoptionId", classeoptionId);
      formData.append("anneeacademiqueId", anneeacademiqueId);
      formData.append("enseignantId", updatedEnseignantId);
      formData.append("heuredebutCours", updatedHeuredebutCours);
      formData.append("heurefinCours", updatedHeurefinCours);
      formData.append("jourId", updatedJourId);
      formData.append("descriptionCours", descriptionCours);  
      try {
        const response = await CoursService.update(formData, token);
  
        if (response.data.status === 200) {
          //redirection sur index
          navigate(myroutes.cours_index);
          Swal.fire({
            icon: "success",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message,
            showConfirmButton: true,
            timer: 3000,
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          text: error.message,
        });
      }
    }
  };
  
 /* const handleSubmitData = async (e) => {
    e.preventDefault();

    const formDataArray = []; 


    // récupérer et mettre à jour les valeurs depuis row

    for (let i = 0; i < rowData.length; i++) {
        const row = rowData[i];

        const updatedMatiereId = row.matiereId;
        setMatiereId(updatedMatiereId);

        const updatedEnseignantId = row.enseignantId;
        setEnseignantId(updatedEnseignantId);


        const updatedHeuredebutCours = row.heuredebutCours;
        setHeuredebutCours(updatedHeuredebutCours);

        const updatedHeurefinCours = row.heurefinCours;
        setheurefinCours(updatedHeurefinCours);

        const updatedJourId = row.jourId;
        setJourId(updatedJourId);

        const formData = new FormData();

        formData.append("matiereId", updatedMatiereId);
        formData.append("classeoptionId", classeoptionId);
        formData.append("anneeacademiqueId", anneeacademiqueId);
        formData.append("enseignantId", updatedEnseignantId);
        formData.append("heuredebutCours", updatedHeuredebutCours);
        formData.append("heurefinCours", updatedHeurefinCours);
        formData.append("jourId", updatedJourId);
        formData.append("descriptionCours", descriptionCours);

       
        formDataArray.push(formData); 
    }

 

    try {
      const response = await CoursService.store(formDataArray, token);

      if (response.data.status === 200) {
        //redirection sur index
        navigate(myroutes.cours_index);
        Swal.fire({
          icon: "success",
          text: response.data.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          text: response.data.message,
          showConfirmButton: true,
          timer: 3000,
        });
      }
    }catch (error) {
      Swal.fire({
        icon: "error",
        text: error.message,
      });
    }
  };*/

  const handleMatiereChange = async (e, index) => {
    const matiereId = e.target.value;
    const tokenValue = token; 
    try {
      const response = await EnseignantsService.getEnseignantsByMatiere(matiereId, tokenValue);
      const enseignantsData = response.data.data; 
      const updatedRowData = [...rowData];
      updatedRowData[index].matiereId = matiereId;
      updatedRowData[index].enseignantId = ""; 
      updatedRowData[index].enseignants = enseignantsData; 
      //console.log(enseignantsData)// Mettez à jour l'état enseignants pour la ligne spécifique
      setRowData(updatedRowData);
    } catch (error) {
      console.error(error);
    }
  }
  
  
//Ajout dynamique de ligne
const addRow = () => {
  setRowData([...rowData, {
    matiereId: "",
    enseignantId: "",
    jourId: "",
    heuredebutCours: "",
    heurefinCours: "",
    enseignants: [],
  }]);
};

//Suppression des lignes ajoutés
const removeRow = (index) => {
  if (rowData.length > 1) {
    const updatedRowData = [...rowData];
    updatedRowData.splice(index, 1);
    setRowData(updatedRowData);
  } else {
    Swal.fire({
      icon: "error",
      text: "Attention, vous ne pouvez pas supprimer cette donnée.",
      showConfirmButton: true,
      timer: 3000,
    });
  }
};

  useEffect(() => {
    // Vérifier si l'utilisateur est connecté lors du chargement de l'application
    dispatch(checkAuthenticate());
    if (!isAuthenticated) {
      //console.log(isAuthenticated)
      //Redirection sur le dashboard
      navigate(myroutes.login);
    }
    fetchAnnesacademiques();
    fetchMatieres();
    fetchJours();
    fetchClasses();
    fetchClassesoptions();
    fetchPersonnes();
    fetchEnseignants();
    edit();
  }, [dispatch]);

  return (
    <Layout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Filarial activeLink={activeLink} />

        <div className="row mb-4 mt-3">
          {/* Bootstrap Validation */}
          <div className="col-md">
            <div className="card shadow-lg">
              <div className="col-md-12 text-center">
                <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2">
                Modification de cours  
                </h5>
              </div>
              <div className="card-body">
                <Row>
                  {Object.keys(validationError).length > 0 && (
                    <div className="row">
                      <div className="col-12">
                        <div className="alert alert-danger">
                          <ul className="mb-0">{<li>{validationError}</li>}</ul>
                        </div>
                      </div>
                    </div>
                  )}
                </Row>
                <Form
                  encType="multipart/form-data"
                  method="POST"
                  onSubmit={handleSubmitData}
                >
                   <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                              <Form.Label
                                className="form-label fw-bold"
                                htmlFor="anneeacademiqueId"
                              >
                               Annee academique <i className="text-danger">*</i>
                              </Form.Label>
                              <Form.Select
                                className=""
                                id="anneeacademiqueId"
                                value={anneeacademiqueId}
                                required
                                onChange={(e) => {
                                  setAnneeacademiqueId(e.target.value);
                                }}
                              >
                                <option value="" selected>
                                  -- Sélectionnez --
                                </option>
                                {anneesacademiques.length > 0 &&
                                  anneesacademiques.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.anneedebutAnneeacademique + ' - ' + item.anneefinAnneeacademique}
                                    </option>
                                  ))}
                              </Form.Select>
                            </div>

                            <div className="col-md-6 mb-3">
                            <Form.Label
                                className="form-label fw-bold"
                                htmlFor="classeoptionId"
                              >
                                Classe option <i className="text-danger">*</i>
                              </Form.Label>
                              <Form.Select
                                className=""
                                id="classeoptionId"
                                value={classeoptionId}
                                required
                                onChange={(e) => {
                                  setClasseoptionId(e.target.value);
                                }}
                              >
                                <option value="" selected>
                                  -- Sélectionnez --
                                </option>
                                {classesoptions.length > 0 &&
                                  classesoptions.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.libelleClasseOption}
                                    </option>
                                  ))}
                              </Form.Select>
                            </div>
                   </div>
                   <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2 text-center">
                      Modifier un cours
                    </h5>
                    <hr/>
                    <Container className="mb-4">
                    <Table id="matable">
                      <thead>
                        <tr>
                          <th className="fw-bold">Matiere</th>
                          <th className="fw-bold">Enseignant</th>
                          <th className="fw-bold">Jour</th>
                          <th className="fw-bold">Heure début</th>
                          <th className="fw-bold">Heure Fin</th>
                          <th className="fw-bold">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rowData.map((row, index) => (
                          <tr key={index}>
                            <td>
                            <Form.Select
                              className=""
                              id={`matiereId-${index}`}
                              value={row.matiereId}
                              required
                              onChange={(e) => handleMatiereChange(e, index)} 

                            >
                                <option value="" selected>
                                  -- Sélectionnez --
                                </option>
                                {matieres.length > 0 &&
                                  matieres.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.libelleMatiere}
                                    </option>
                                  ))}
                              </Form.Select>
                            </td>
                            <td>
                            <Form.Select
                                className=""
                                id={`enseignantId-${index}`}
                                value={row.enseignantId}
                                required
                                onChange={(e) => {
                                const updatedRowData = [...rowData];
                                updatedRowData[index].enseignantId = e.target.value;
                                setRowData(updatedRowData);
                              }}
                                 >
                                <option value="" selected>
                                  -- Sélectionnez --
                                </option>
                                {row.enseignants.length > 0 &&
                                  row.enseignants.map((item) => (
                                    <option key={item.id} value={item.id} selected={item.id === row.enseignantId}
                                    >
                                      {item.personnes.nomPersonne} {item.personnes.prenomsPersonne}
                                    </option>
                                  ))}
                              </Form.Select>
                            </td>
                            <td>
                            <Form.Select
                              className=""
                              id={`jourId-${index}`}
                              value={row.jourId}
                              required
                              onChange={(e) => {
                                const updatedRowData = [...rowData];
                                updatedRowData[index].jourId = e.target.value;
                                setRowData(updatedRowData);
                              }}
                            >
                                <option value="" selected>
                                  -- Sélectionnez --
                                </option>
                                {jours.length > 0 &&
                                  jours.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.libelleJour}
                                    </option>
                                  ))}
                              </Form.Select>
                            </td>
                            <td>
                            <Form.Control
                              className="form-control"
                              id={`heuredebutCours-${index}`}
                              value={row.heuredebutCours}
                              type="time"
                              placeholder=""
                              name="heuredebutCours"
                              onChange={(e) => {
                                const updatedRowData = [...rowData];
                                updatedRowData[index].heuredebutCours = e.target.value + ":00";
                                setRowData(updatedRowData);
                              }}
                            />
                            </td>
                            <td>
                            <Form.Control
                              className="form-control"
                              id={`heurefinCours-${index}`}
                              value={row.heurefinCours}
                              type="time"
                              placeholder=""
                              name="heurefinCours"
                              onChange={(e) => {
                                const updatedRowData = [...rowData];
                                updatedRowData[index].heurefinCours = e.target.value + ":00";
                                setRowData(updatedRowData);
                              }}
                            />
                            </td>
                            <td>
                              {index === 0 ? (
                                <Button id="btnadd" onClick={addRow}>
                                  Ajouter
                                </Button>
                              ) : (
                                <Button
                                  id="btnsupprimer"
                                  variant="danger"
                                  onClick={() => removeRow(index)}
                                >
                                  Supprimer
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Container>

                          <div className="col-md-12">
                          <div className=" mb-3">
                            <Form.Label
                              className="form-label fw-bold"
                              htmlFor="descriptionCours"
                            >
                              Description <i className="text-danger"></i>
                            </Form.Label>
                            <textarea
                              className="form-control"
                              value={descriptionCours}
                              id="descriptionCours"
                              onChange={(e) => setDescriptionCours(e.target.value)}
                              name="descriptionCours"
                              rows="3"
                            ></textarea>
                          </div>
                            </div>                    
                  <div className="col-md-8 mt-4 ">
                    <div className="row">
                      <div className="col-md-3 ">
                        <button type="submit" className="btn btn-primary">
                          Enregistrer
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
          {/* /Bootstrap Validation */}

          <>
            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title className="text-white">
                  Enregistrement matière
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form
                  className="needs-validation"
                  noValidate
                  onSubmit={storeMatiere}
                >
                  <div className="row">
                    <div className=" col-md-6 mb-3">
                      <Form.Label className="form-label fw-bold" htmlFor="name">
                        Libelle <i className="text-danger">*</i>
                      </Form.Label>
                      <Form.Control
                        className="form-control"
                        id="libelleMatiere"
                        type="text"
                        value={libelleMatiere}
                        onChange={(e) => setLibelleMatiere(e.target.value)}
                        placeholder=""
                        required={true}
                        maxLength={100}
                        minLength={3}
                      />
                    </div>

                    <div className=" col-md-6 mb-3">
                      <Form.Label className="form-label fw-bold" htmlFor="name">
                        Coefficient <i className="text-danger">*</i>
                      </Form.Label>
                      <Form.Control
                        className="form-control"
                        id="coefficientMatiere"
                        type="number"
                        value={coefficientMatiere}
                        onChange={(e) => setCoefficientMatiere(e.target.value)}
                        placeholder=""
                        required={true}
                        maxLength={30}
                        minLength={1}
                      />
                    </div>
                  </div>

                  <div className=" mb-3">
                    <Form.Label
                      className="form-label fw-bold"
                      htmlFor="descriptionMatiere"
                    >
                      Description <i className="text-danger"></i>
                    </Form.Label>
                    <textarea
                      className="form-control"
                      id="descriptionMatiere"
                      onChange={(e) => setDescriptionMatiere(e.target.value)}
                      name="descriptionMatiere"
                      rows="3"
                    ></textarea>
                  </div>

                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                      Fermer
                    </Button>
                    <Button
                      variant="primary"
                      type="submit"
                      onClick={handleClose}
                    >
                      Enregistrer
                    </Button>
                  </Modal.Footer>
                </Form>
              </Modal.Body>
            </Modal>
          </>
        </div>
      </div>
    </Layout>
  );
}
